import React, { useState, useRef, useEffect } from 'react';
import CryptoJS from "crypto-js";
import PropTypes from 'prop-types';
import StartValidationDescription from './StartValidationDescription';
import StartValidationInstructions from './StartValidationInstructions';
import { ContainerFlex } from '@prima-afp/prima-ui-design-system/dist/layouts';
import { Button } from "@prima-afp/prima-ui-elements/dist/core";
import { useHistory, useLocation } from "react-router-dom";
import { useStateDigitalTransfersContext, useDispatchDigitalTransfersContext } from "../../../../context/DigitalTransfersContext";
import { TocBiometricRoutes } from "../../../../constants";
import * as MODULES_CONFIG from "../../../../../../router/config";
import PermissionsModal from "../../../../componentes-sin-asesor/StepFundType/PermissionsModal";
import { getUtmData, getDataDevice } from "../../../../constants/sendToDataLayer";
import { updateUrl } from "../../../../constants/updateUrl";
import { ContainerRecoToc }  from "../../../Style";


const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const RecomendationsToc = ({ componentButton = null }) => {

  const state = useStateDigitalTransfersContext();
  const [timer, setTimer] = useState(12);
  let interval = useRef();

  const query = useQuery();
  const history = useHistory();
  const { userWeb } = state;
  const [permissionsWarning, setPermissionsWarning] = useState(null);
  const [showPreventiveModal, setShowPreventiveModal] = useState(null);
  const urlPublicZoneWithImages = "https://www.prima.com.pe/public-zone/images/webTransactional/biometriaToc/";
  const dispatch = useDispatchDigitalTransfersContext();


  useEffect(() => {

    let copyOfTimer = 12;
    interval.current = setInterval(() => {
      if (copyOfTimer > 0) {
        copyOfTimer--;
        setTimer(copyOfTimer);
      } else { clearInterval(interval.current)
        GoToBiometricValidation();
       }
    }, 1000);

    return () => clearInterval(interval.current);
  }, []);


  const deviceInfo = getDataDevice();

  const saveUserWebInSessionStorage = () => {
    const payloadContext = {
      age: userWeb.age,
      documentType: userWeb.documentType,
      documentNumber: userWeb.documentNumber,
      tcConfirmation: userWeb.tcConfirmation,
      adpConfirmation: userWeb.adpConfirmation,
      pepInstitutionName: userWeb.pepInstitutionName,
      pepPositionHeld: userWeb.pepPositionHeld,
      heldPosition: userWeb.heldPosition,
      firstName: userWeb.firstName,
      email: userWeb.email,
      phoneNumber: userWeb.phoneNumber,
      address: userWeb.address,
      workerType: userWeb.workerType,
      rucEmployer: userWeb.rucEmployer,
      tradeNameEmployer: userWeb.tradeNameEmployer,
      codeFundType: userWeb.codeFundType,
      fundType: userWeb.fundType
    };
  
    const secretKey = sessionStorage.getItem("timestampFirstQuery");
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payloadContext),
      secretKey
    ).toString();
    sessionStorage.setItem("userWeb", encryptedPayload);
  };

  const goNextStep = async () => {
    if (userWeb.useToc == true && 
      userWeb.documentNumber != null &&
      userWeb.documentNumber !== "" &&
      /^[0-9]{8}$/.test(userWeb.documentNumber))
    {

      const urlTocConfig = TocBiometricRoutes(
        MODULES_CONFIG.genericProcedureBiometricTOCConfig.pathBase
      ).START_VALIDATION_PROCESS;
      const utmParamsToToc = getUtmData({}, window.location.href);
      const data = {
        state: {
          documentNumber: userWeb.documentNumber,
          utmParams: utmParamsToToc,
          fromConsumerModule: true,
        },
      };
      sessionStorage.setItem("timestampFirstQuery", Date.now());
      sessionStorage.setItem(
        "location-state-store",
        JSON.stringify(data)
      );
      sessionStorage.setItem('skipReco', 'NO_SKIP');
      sessionStorage.setItem('flowType', 'SIN_ASESOR');
      saveUserWebInSessionStorage();

      history.push({
        pathname: urlTocConfig,
        state: {
          documentNumber: userWeb.documentNumber,
          fromConsumerModule: true,
          utmParams: utmParamsToToc,
        },
      });
    }
  };

  const GoToBiometricValidation = async () => {
    navigator.permissions.query({ name: 'camera' })
      .then((permissionStatus) => {
        if (permissionStatus.state === 'granted') {
          goNextStep(true);
        } else if (permissionStatus.state === 'denied') {
          setPermissionsWarning(false);
        }
        else if (permissionStatus.state === 'prompt' || permissionStatus.state === null) {
          setShowPreventiveModal(true);
        }
      })
      .catch((error) => {
        console.error('Error al comprobar el permiso de la cámara:', error);
      });

  };

  const BlockedCamera = () => {
    window.location.reload();
  };

  const checkCameraPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      // Detener el stream de video para liberar la cámara
      stream.getTracks().forEach(track => track.stop());
      return true;
    } catch (error) {
      return 'false';
    }
  };

  const askPermissisons = async () => {
    const statusPermisos = await checkCameraPermission();
    setShowPreventiveModal(false);
    if (statusPermisos === 'false' || statusPermisos === false) {
      setPermissionsWarning(false);
    } else if (statusPermisos === 'true' || statusPermisos === true) {
      goNextStep(true);
    }
  };

  return (

      <ContainerRecoToc>
 
        <StartValidationDescription
          timerToStartValidation={timer}
        />
        <StartValidationInstructions />
        <Button
          className={ "newUiBtn enabledBtn"}
          onClick={() => GoToBiometricValidation()}
        >
          Continuar
        </Button>

        <PermissionsModal
          permissionsWarning={permissionsWarning}
          showPreventiveModal={showPreventiveModal}
          deviceInfo={deviceInfo}
          urlPublicZoneWithImages={urlPublicZoneWithImages}
          BlockedCamera={BlockedCamera}
          askPermissions={askPermissisons}
        />

      </ContainerRecoToc>
  );
};

RecomendationsToc.propTypes = {
  componentButton: PropTypes.node,
};

RecomendationsToc.defaultProps = {
  componentButton: null,
};

export default RecomendationsToc;